export default {
  label: {
    en: 'Rating:',
  },
  hint: {
    en: 'Click to rate',
  },
}
